import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Component({
  selector: 'wrapped-column',
  templateUrl: './wrapped-column.component.html',
  styleUrls: ['./wrapped-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class WrappedColumnComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  readonly additionData = input(new BehaviorSubject(null));

  /**
   * Gets additionData source - handles both input signal (when used directly)
   * and Observable property (when set directly by GridCellComponent)
   */
  getAdditionDataSource(): Observable<any> {
    // Check if additionData is set directly as Observable property (by GridCellComponent)
    // When GridCellComponent sets it, it's not a signal anymore, just a property
    if (
      this.additionData &&
      typeof this.additionData !== 'function' &&
      typeof (this.additionData as any).subscribe === 'function'
    ) {
      return this.additionData as any;
    }
    // Otherwise, treat as input signal
    try {
      const signalValue = this.additionData();
      if (signalValue && typeof signalValue.subscribe === 'function') {
        return signalValue;
      }
      return of(null);
    } catch {
      return of(null);
    }
  }

  /**
   * Getter for template - returns Observable for async pipe
   */
  get additionData$(): Observable<any> {
    return this.getAdditionDataSource();
  }
}
